import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import InputDebtorSelector from '../../InputSpecialFields/InputDebtorSelector';
import InputCaseSelector from '../../InputSpecialFields/InputCaseSelector';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditVerification = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        type: 'Плановая',
        complaint: '',
        applicant: '',
        debtor_id: '',
        debtor_name: '',
        case_id: '',
        case_number: '',
        date: '',
        results: '',
        actions: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-verification?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.type) {
            newErrors.type = 'Обязательное поле';
        }

        if (!formInfo.complaint) {
            newErrors.complaint = 'Обязательное поле';
        }
        if (formInfo.complaint && (formInfo.complaint.length < 2 || formInfo.complaint.length > 250)) {
            newErrors.complaint = 'Значение не может быть меньше 2 и более 250 символов';
        }
        if (!formInfo.applicant) {
            newErrors.applicant = 'Обязательное поле';
        }
        if (formInfo.applicant && (formInfo.applicant.length < 2 || formInfo.applicant.length > 80)) {
            newErrors.applicant = 'Значение не может быть меньше 2 и более 80 символов';
        }

        if (!formInfo.case_id) {
            newErrors.case = 'Обязательное поле';
        }
        if (!formInfo.date) {
            newErrors.date = 'Обязательное поле';
        }
        
        if (!formInfo.results) {
            newErrors.applicant = 'Обязательное поле';
        }
        if (formInfo.actions && (formInfo.actions.length < 2 || formInfo.actions.length > 400)) {
            newErrors.actions = 'Значение не может быть меньше 2 и более 400 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const token = localStorage.getItem('token');
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('type', formInfo.type);
        formData.append('complaint', formInfo.complaint);
        formData.append('applicant', formInfo.applicant);
        formData.append('debtor_id', formInfo.debtor_id);
        formData.append('case_id', formInfo.case_id);
        formData.append('date', normalizeDate(formInfo.date));
        formData.append('results', formInfo.results);
        formData.append('actions', formInfo.actions);

        if (files.verifDocs && files.verifDocs.length > 0) {
            files.verifDocs.forEach((file) => {
                formData.append('file_verification_docs', file);
            });
        }

        axios.put('/api/add-new-verification', formData, {
            headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
            },
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onSuccess();
            openTimeModal('Данные успешно добавлены', 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        });
    };

    const changeData = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-verification`, {
            id: formInfo.id,
            user_id: userId,
            type: formInfo.type,
            applicant: formInfo.applicant,
            debtor_id: formInfo.debtor_id,
            case_id: formInfo.case_id,
            date: normalizeDate(formInfo.date),
            results: formInfo.results,
            actions: formInfo.actions,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        verifDocs: null,
    });


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений о проверке
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Тип проверки</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper'>
                                <label className={`radioSwitchLabel ${formInfo.type === 'Плановая' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Плановая'
                                        checked={formInfo.type === 'Плановая'}
                                        onChange={handleChange('type')}
                                    />
                                    <span>Плановая</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.type === 'Внеплановая' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Внеплановая'
                                        checked={formInfo.type === 'Внеплановая'}
                                        onChange={handleChange('type')}
                                    />
                                    <span>Внеплановая</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Жалоба</a>
                        <div className='labelInputRight'>
                            {/* <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.complaint} 
                                onChange={handleChange('complaint')} 
                                className={errorsForm.complaint ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='200' 
                                disabled={loading}
                                required />
                                {errorsForm.complaint && <div className='errorUnderInput'>{errorsForm.complaint}</div>}
                            </div> */}
                            <div className='inputWrapper'>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.complaint}  
                                    onChange={handleChange('complaint')}
                                    minLength='' 
                                    maxLength='250' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{formInfo.complaint.length}/250</p>
                                {errorsForm.complaint && <div className='errorUnderInput'>{errorsForm.complaint}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Заявитель</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.applicant} 
                                onChange={handleChange('applicant')} 
                                className={errorsForm.applicant ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='80' 
                                disabled={loading}
                                required />
                                {errorsForm.applicant && <div className='errorUnderInput'>{errorsForm.applicant}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Должник</a>
                        <div className='labelInputRight'>
                            <InputDebtorSelector
                                initialSearchTerm={formInfo.debtor_name}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                            />
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Номер дела</a>
                        <div className='labelInputRight'>
                            <InputCaseSelector
                                initialSearchTerm={formInfo.case_name}
                                formInfo={formInfo}
                                setFormInfo={setFormInfo}
                                errorsForm={errorsForm}
                                setErrorsForm={setErrorsForm}
                            />
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата проведения</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.date?.split('T')[0]}
                                onChange={handleChange('date')} 
                                className={errorsForm.date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.date && <div className='errorUnderInput'>{errorsForm.date}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Результат</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper'>
                                <label className={`radioSwitchLabel ${formInfo.results === 'Нарушения установлены' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Нарушения установлены'
                                        checked={formInfo.results === 'Нарушения установлены'}
                                        onChange={handleChange('results')}
                                    />
                                    <span>Нарушения установлены</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.results === 'Нарушения не установлены' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Нарушения не установлены'
                                        checked={formInfo.results === 'Нарушения не установлены'}
                                        onChange={handleChange('results')}
                                    />
                                    <span>Нарушения не установлены</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Принятое решение</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.actions}  
                                    onChange={handleChange('actions')}
                                    minLength='' 
                                    maxLength='400' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{formInfo.actions.length}/400</p>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Файлы</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить файлы'
                                        file={files.verifDocs}
                                        buttonLabel='Прикрепить файлы'
                                        onChange={(e) => setFiles(prev => ({ ...prev, verifDocs: Array.from(e.target.files) }))}
                                        onReset={(indexToRemove) =>
                                            setFiles(prev => ({
                                                ...prev,
                                                verifDocs: prev.verifDocs.filter((_, i) => i !== indexToRemove),
                                            }))
                                        }
                                        allowMultiple={true}
                                    />
                                    {errorsForm.report_files && <div className='errorUnderInput'>{errorsForm.report_files}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файлов у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditVerification;